import SignoutOidc from './SignoutOidc';

const SigninOidcConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'signout-oidc',
      element: <SignoutOidc />,
    },
  ],
};

export default SigninOidcConfig;
